/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApprovalRequest } from './approvalRequest';

export type RequestModuleVersionApprovalBody = ApprovalRequest | null;
